import AppealsDynamicWidget from './component'

export default AppealsDynamicWidget
